module.exports = __webpack_public_path__ + "img/360.baeeb2bc.svg";